const INTERACTION_TARGETS = "button, a, input, select, textarea, label, [role='button']";
const DOUBLE_TAP_WINDOW_MS = 325;

type ClosableTarget = EventTarget & {
  closest?: (selector: string) => EventTarget | null;
};

function closestTarget(target: EventTarget | null, selector: string): EventTarget | null {
  const candidate = target as ClosableTarget | null;
  return typeof candidate?.closest === "function" ? candidate.closest(selector) : null;
}

export function isMapGestureTarget(target: EventTarget | null): boolean {
  return Boolean(closestTarget(target, ".leaflet-container"));
}

function comparableTapTarget(target: EventTarget | null): EventTarget | null {
  return closestTarget(target, INTERACTION_TARGETS) ?? target;
}

export function installAccidentalZoomGuard(doc: Document = document): () => void {
  let previousTapAt = 0;
  let previousTapTarget: EventTarget | null = null;

  const preventPageGesture = (event: Event): void => {
    if (!isMapGestureTarget(event.target)) event.preventDefault();
  };

  const preventRepeatedTapZoom = (event: TouchEvent): void => {
    if (isMapGestureTarget(event.target) || event.changedTouches.length !== 1) return;
    const now = Date.now();
    const target = comparableTapTarget(event.target);
    if (target === previousTapTarget && now - previousTapAt <= DOUBLE_TAP_WINDOW_MS) {
      event.preventDefault();
    }
    previousTapAt = now;
    previousTapTarget = target;
  };

  doc.addEventListener("gesturestart", preventPageGesture, { passive: false });
  doc.addEventListener("gesturechange", preventPageGesture, { passive: false });
  doc.addEventListener("gestureend", preventPageGesture, { passive: false });
  doc.addEventListener("touchend", preventRepeatedTapZoom, { passive: false });

  return () => {
    doc.removeEventListener("gesturestart", preventPageGesture);
    doc.removeEventListener("gesturechange", preventPageGesture);
    doc.removeEventListener("gestureend", preventPageGesture);
    doc.removeEventListener("touchend", preventRepeatedTapZoom);
  };
}
